import { Outlet } from 'react-router-dom'

import { FlexLayout } from 'layouts'

import { NavBar } from './NavBar'

import './styles.scss'

const SectionsLayout = () => {
  return (
    <FlexLayout.Container vertical>
      <FlexLayout.Content>
        <Outlet />
      </FlexLayout.Content>
      <NavBar />
    </FlexLayout.Container>
  )
}

export default SectionsLayout
